import moment from 'moment-timezone'

const DEFAULT_FORMAT = 'DD.MM.YYYY'

export const formatDate = (isoDate, dateFormat = DEFAULT_FORMAT) =>
  (isoDate && moment(isoDate).format(dateFormat)) || ''
